import {Component, OnDestroy, OnInit} from '@angular/core';
import {version} from '../../../../package.json';
import {Router, ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {AuthService} from '../../service/auth.service';
import {BusinessProfile} from '../../model/account';
import {MatSelectChange} from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  appVersion: string = version;
  initials = '';
  sidenavOpened: boolean = localStorage.getItem('iot4bos.sidebar.opened') ?
    localStorage.getItem('iot4bos.sidebar.opened') === 'true' :
    true;
  businessProfile: BusinessProfile;
  businessProfiles: BusinessProfile[];
  deviceName: string;
  deviceIdentifier: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private translationService: TranslateService) {
      if ('deviceName' in route.snapshot.queryParams) {
        // The display will be restricted to this device
        this.deviceName = route.snapshot.queryParams.deviceName;
      }
      if ('deviceIdentifier' in route.snapshot.queryParams) {
        // The display will be restricted to this device
        this.deviceIdentifier = route.snapshot.queryParams.deviceIdentifier;
      }
  }

  ngOnInit() {
    this.subscriptions.push(this.authService.businessProfileChanged.subscribe(profile => this.businessProfile = profile));
    this.subscriptions.push(this.authService.accountChanged.subscribe(account => {
      this.initials = `${account.firstName.slice(0, 1).toUpperCase()}${account.lastName?.slice(0, 1).toUpperCase()}`;
      this.businessProfiles = account.businessProfiles;
      if (this.businessProfile) {
        this.businessProfile = this.businessProfiles.find(bp => bp.id === this.businessProfile.id) ?? this.businessProfile;
      }

      this.translationService.use(account.preferences.appLanguage);
    }));
    this.authService.refreshBusinessProfile();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  goHome() {
    this.router.navigate(['/home']);
  }

  toggleSideNav() {
    this.sidenavOpened = !this.sidenavOpened;
    localStorage.setItem('iot4bos.sidebar.opened', this.sidenavOpened.toString());
  }

  switchBusinessProfile($event: MatSelectChange) {
    this.authService.selectBusinessProfile($event.value);
  }

  onLogout() {
    this.authService.signOut();
  }
}
